// Toast.js
import React from 'react';
import './Toast.css'; // Create a CSS file for styling

const Toast = ({ message, onClose }) => {
    return (
        <div className="toast">

            <h1>{message}</h1>
            <button onClick={onClose}>Close</button>
        </div>
    );
};

export default Toast;
